import { render, staticRenderFns } from "./SurveyCard.vue?vue&type=template&id=1e52858e&scoped=true&"
import script from "./SurveyCard.vue?vue&type=script&lang=js&"
export * from "./SurveyCard.vue?vue&type=script&lang=js&"
import style0 from "./SurveyCard.vue?vue&type=style&index=0&id=1e52858e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52858e",
  null
  
)

export default component.exports